export const MAP_ELEMENT__Z_INDICES = {
  MARKER: 1,
  SUBJECT_MARKER: 2,
  SELECTED_MARKER: 3,
  SELECTED_SUBJECT_MARKER: 4,
  POPUP: 4,
}

export const DEFAULT_FIT_BOUNDS_PADDING = 32
